import { useMemo } from "react";

import type { ScreenMembersOnLoginPassword } from "@auth0/auth0-acul-js";
import LoginPasswordInstance from "@auth0/auth0-acul-js/login-password";

import { executeSafely } from "../utils/helpers/executeSafely";

export const useLoginPasswordManager = () => {
  const loginPasswordInstance = useMemo(() => new LoginPasswordInstance(), []);

  const { transaction, screen } = loginPasswordInstance;
  const { isSignupEnabled, isForgotPasswordEnabled } = transaction;
  const {
    signupLink,
    resetPasswordLink,
    texts,
    captchaImage,
    editIdentifierLink,
    data,
  } = screen;

  const handleLoginPassword = async (
    loginId: string,
    password: string,
    captcha?: string
  ): Promise<void> => {
    const options: { username: string; password: string; captcha?: string } = {
      username: loginId?.trim() || "",
      password: password || "",
    };

    if (screen.isCaptchaAvailable && captcha?.trim()) {
      options.captcha = captcha.trim();
    }

    executeSafely(
      `LoginPassword with options: ${JSON.stringify({ ...options, password: "********" })}`,
      () => loginPasswordInstance.login(options)
    );
  };

  return {
    loginPasswordInstance,
    handleLoginPassword,
    texts: (texts || {}) as ScreenMembersOnLoginPassword["texts"],
    isSignupEnabled: isSignupEnabled === true,
    isForgotPasswordEnabled: isForgotPasswordEnabled === true,
    isCaptchaAvailable: screen.isCaptchaAvailable === true,
    errors: loginPasswordInstance.getError(),
    editIdentifierLink,
    signupLink,
    resetPasswordLink,
    captchaImage,
    prefilledIdentifier:
      (typeof data?.username === "string" && data.username) || "",
  };
};
